const awsConfig = {
    Auth: {
        Cognito: {
            userPoolId: 'us-east-2_0xgcThe9m',
            userPoolClientId: '338lqdrfg6df30qcs2eaddvc6m',
            loginWith: {
                email: true,
            },
        },
    },
};

export default awsConfig;

